export default {
  "24": "https://editor.mobilibus.com/web/bus2you/1sb79#hevg",
  "23": "https://editor.mobilibus.com/web/bus2you/1sb79#hevf",
  "22": "https://editor.mobilibus.com/web/bus2you/1sb79#hevi",
  "40": "https://editor.mobilibus.com/web/bus2you/1sb79#hf5c",
  "21": "https://editor.mobilibus.com/web/bus2you/1sb79#hf56",
  "20": "https://editor.mobilibus.com/web/bus2you/1sb79#hf57",
  "19": "https://editor.mobilibus.com/web/bus2you/1sb79#hf5a",
  "18": "https://editor.mobilibus.com/web/bus2you/1sb79#hf3u",
  "17": "https://editor.mobilibus.com/web/bus2you/1sb79#hf5f",
  "16": "https://editor.mobilibus.com/web/bus2you/1sb79#hf5e",
  "15": "https://editor.mobilibus.com/web/bus2you/1sb79#hf5h",
  "14": "https://editor.mobilibus.com/web/bus2you/1sb79#hf5g",
  "12": "https://editor.mobilibus.com/web/bus2you/1sb79#hf58",
  "28": "https://editor.mobilibus.com/web/bus2you/1sb79#hf0v",
  "29": "https://editor.mobilibus.com/web/bus2you/1sb79#hf10",
  "30": "https://editor.mobilibus.com/web/bus2you/1sb79#hf11",
  "31": "https://editor.mobilibus.com/web/bus2you/1sb79#hf1k",
  "32": "https://editor.mobilibus.com/web/bus2you/1sb79#hf1j",
  "33": "https://editor.mobilibus.com/web/bus2you/1sb79#hf1n",
  "43": "https://editor.mobilibus.com/web/bus2you/1sb79#hf0b",
  "34": "https://editor.mobilibus.com/web/bus2you/1sb79#hf1d",
  "44": "https://editor.mobilibus.com/web/bus2you/1sb79#hf09",
  "35": "https://editor.mobilibus.com/web/bus2you/1sb79#hf1l",
  "36": "https://editor.mobilibus.com/web/bus2you/1sb79#hf19",
  "37": "https://editor.mobilibus.com/web/bus2you/1sb79#hf18",
  "38": "https://editor.mobilibus.com/web/bus2you/1sb79#hf07",
  "39": "https://editor.mobilibus.com/web/bus2you/1sb79#hf0d",
  "27": "https://editor.mobilibus.com/web/bus2you/1sb79#hf1c",
  "26": "https://editor.mobilibus.com/web/bus2you/1sb79#hf1b",
  "25": "https://editor.mobilibus.com/web/bus2you/1sb79#hf0f"
}
